import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const IMG =
  "https://images.pexels.com/photos/37730212/pexels-photo-37730212.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const POINTS = [
  "Single accountable partner — hardware to cyber defense",
  "Multi-brand ecosystem beyond Microsoft products",
  "Certified VAPT, DPDP & ISO compliance practice",
  "SLA-backed AMC with 24/7 remote helpdesk",
];

export const About = () => (
  <section id="about" data-testid="about-section" className="relative py-28 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-14 items-center">
      <motion.div
        initial={{ opacity: 0, clipPath: "inset(0 100% 0 0)" }}
        whileInView={{ opacity: 1, clipPath: "inset(0 0% 0 0)" }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
        className="lg:col-span-5 relative order-2 lg:order-1"
      >
        <div className="rounded-2xl overflow-hidden border border-white/15 shadow-[0_40px_80px_-20px_rgba(0,0,0,0.7)]">
          <img
            src={IMG}
            alt="Data center infrastructure close-up"
            className="w-full h-[440px] object-cover saturate-[0.7] contrast-110"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ark-950/80 via-transparent to-transparent" />
        </div>
        <div className="absolute -bottom-6 -right-4 lg:-right-8 px-6 py-5 rounded-2xl glass border border-white/15 shadow-2xl">
          <p className="font-display text-3xl font-bold metallic-text">10+</p>
          <p className="font-mono text-[10px] tracking-[0.25em] text-slate-400 uppercase mt-1">
            Years of Field Engineering
          </p>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8 }}
        className="lg:col-span-7 order-1 lg:order-2"
      >
        <p className="font-mono text-xs tracking-[0.3em] text-cyan-400 uppercase font-semibold">
          05 // Who We Are
        </p>
        <h2 className="mt-4 font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-slate-100 leading-tight">
          Professional IT Support. Security. Connectivity.{" "}
          <span className="metallic-text">Business Solutions.</span>
        </h2>
        <p className="mt-6 text-base text-slate-400 leading-relaxed max-w-2xl">
          ARK IT ENTERPRISES is a full-spectrum IT infrastructure and solutions company
          headquartered in Navi Mumbai. From a single laptop repair to architecting
          enterprise networks, security operations and cloud ecosystems — we design,
          deploy and manage the technology your business runs on.
        </p>
        <div className="mt-8 grid sm:grid-cols-2 gap-4">
          {POINTS.map((p, i) => (
            <motion.div
              key={p}
              initial={{ opacity: 0, x: -16 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="flex items-start gap-3 text-sm text-slate-300"
            >
              <CheckCircle2 size={16} className="mt-0.5 shrink-0 text-cyan-400" />
              {p}
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);
